<template>
  <div class="container-fluid mt-5">
    <!-- Header Section -->
    <div
      class="d-flex flex-wrap flex-column flex-sm-row mb-3 justify-content-between"
    >
      <div>
        <div class="d-flex align-items-center">
          <div class="s-32 font-weight-bold text-head text-black">
            Asset Maintenance History
          </div>
        </div>
        <BackRoute />
      </div>
      <div class="d-flex flex-column flex-sm-row link">
        <el-button
          @click="openMaintenanceModal"
          :color="primarycolor"
          class="header-btn w-100 mt-3 mt-sm-0"
          round
        >
          New Maintenance
        </el-button>
      </div>
    </div>

    <!-- Table Section -->
    <div class="row">
      <div class="container-fluid px-0 mt-5">
        <div class="col-md-12" v-loading="loading">
          <div v-if="maintenanceData.length > 0">
            <TableSearch
              :data="filteredData"
              :headers="maintenanceHeaders"
              @update:searchText="handleSearchTextUpdate"
              :checkMultipleItem="false"
              :filterItem="false"
            >
              <template v-slot:maintenanceDate="{ item }">
                <div class="" @click="openEditModal(item.id)">
                  {{ date(item.maintenanceDate) }}
                </div>
              </template>
              <template v-slot:details="{ item }">
                <div class="c-pointer" @click="openEditModal(item.id)">
                  {{ item.details }}
                </div>
              </template>
              <template v-slot:cost="{ item }">
                <div class="c-pointer" @click="openEditModal(item.id)">
                  {{ item.cost.toLocaleString() || "" }}
                </div>
              </template>
              <template v-slot:maintenanceAgent="{ item }">
                <div class="c-pointer" @click="openEditModal(item.id)">
                  {{ item.maintenanceAgent }}
                </div>
              </template>
              <template v-slot:scheduledDate="{ item }">
                <div class="c-pointer" @click="openEditModal(item.id)">
                  {{ date(item.scheduledDate) }}
                </div>
              </template>
              <template v-slot:status="{ item }">
                <div class="c-pointer" @click="openEditModal(item.id)">
                  {{ maintenanceStatus[item.status] }}
                </div>
              </template>

              <template v-slot:action="{ item }">
                <el-dropdown trigger="click">
                  <el-icon><MoreFilled /></el-icon>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item @click="openEditModal(item.id)">
                        Edit
                      </el-dropdown-item>
                      <el-dropdown-item @click="deleteMaintenance(item.id)">
                        Delete
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
            </TableSearch>
          </div>
          <div v-else class="text-center py-5">
            <el-empty description="No maintenance records available" />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <el-dialog
      v-model="displayModal"
      :title="isEditing ? 'Edit Maintenance' : 'New Maintenance'"
      :width="mdAndUp || lgAndUp || xlAndUp ? '50%' : '90%'"
      class="border-radius-8"
      :close-on-click-modal="false"
    >
      <div class="p-4">
        <!-- Form Fields -->
        <div class="row mt-3 align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Date</label>
          </div>
          <div class="col-md-9">
            <el-date-picker
              v-model="form.maintenanceDate"
              type="date"
              format="DD/MM/YYYY"
              size="large"
              class="w-100"
            />
          </div>
        </div>
        <div class="row align-items-center mt-3">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Asset Name</label>
          </div>
          <div class="col-md-9">
            <el-select-v2
              v-model="selectedAssetId"
              @change="setSelectedAsset"
              :options="
                assets.map((i) => ({
                  label: i.name,
                  value: i.id,
                }))
              "
              placeholder="Select"
              size="large"
              class="w-100"
            />
          </div>
        </div>
        <div class="row mt-3 align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Details</label>
          </div>
          <div class="col-md-9">
            <el-input
              v-model="form.details"
              placeholder="Enter process"
              class="w-100"
            />
          </div>
        </div>

        <div class="row mt-3 align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Cost</label>
          </div>
          <div class="col-md-9">
            <el-input
              v-model="form.cost"
              placeholder="Enter cost"
              class="w-100"
            />
          </div>
        </div>

        <div class="row mt-3 align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Company/Person</label>
          </div>
          <div class="col-md-9">
            <el-input
              v-model="form.maintenanceAgent"
              placeholder="Enter company/person"
              class="w-100"
            />
          </div>
        </div>

        <div class="row mt-3 align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Next Schedule</label>
          </div>
          <div class="col-md-9">
            <el-date-picker
              v-model="form.scheduledDate"
              type="date"
              format="DD/MM/YYYY"
              size="large"
              class="w-100"
            />
          </div>
        </div>
        <div class="row mt-3 align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Status</label>
          </div>
          <div class="col-md-9">
            <el-select-v2
              v-model="form.status"
              :options="
                maintenanceStatus.map((i) => ({
                  label: i,
                  value: i,
                }))
              "
              placeholder="Select"
              size="large"
              class="w-100"
            />
          </div>
        </div>

        <div class="row mt-4 justify-content-center align-items-center">
          <div class="col-md-5">
            <el-button
              round
              :color="primarycolor"
              class="w-100 text-white"
              @click="handleSubmit"
            >
              {{ isEditing ? "Update" : "Save & Continue" }}
            </el-button>
            <el-button
              round
              link
              class="w-100 text-dak"
              @click="displayModal = false"
            >
              Close
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, inject } from "vue";
import BackRoute from "../../components/backroute/BackRoute.vue";
// import TableNoExport2 from "../../components/table/TableNoExport2.vue";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import { ElNotification, ElMessageBox } from "element-plus";
import assetService from "../../services/asset/assetServices";
import monthDayYear from "../../services/dates/dateformatter";
import TableSearch from "../../components/table/TableSearch.vue";

const primarycolor = inject("primarycolor");
const maintenanceData = ref([]);
const searchText = ref("");
const displayModal = ref(false);
const loading = ref(false);
const isEditing = ref(false);
const currentEditId = ref(null);
const selectedAssetId = ref(null);
const assets = ref([]);
const selectedAsset = ref({});
const textHead = ref("All Maintenance Records");
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
const maintenanceStatus = ["Scheduled", "InProgress", "Completed", "Cancelled"];

const maintenanceHeaders = ref([
  { name: "DATE", value: "maintenanceDate" },
  { name: "DETAILS", value: "details" },
  { name: "COST", value: "cost" },
  { name: "Company/Person", value: "maintenanceAgent" },
  { name: "Next Schedule", value: "scheduledDate" },
  { name: "SATUS", value: "status" },
  { name: "Action", value: "action" },
]);

const form = ref({
  assetId: "", // required
  details: "", // maps from process input
  maintenanceAgent: "", // maps from company/person input
  cost: "",
  scheduledDate: "", // maps from nextSchedule date picker
  maintenanceDate: "", // optional, or set default as Date.now
  //   frequency: 0,
  defaultImageUrl: "",
  //   image2Url: "",
  //   image3Url: "",
  status: null,
});

const setSelectedAsset = () => {
  selectedAsset.value = assets.value.find((asset) => {
    return asset.id === selectedAssetId.value;
  });
  form.value.assetId = selectedAsset.value ? selectedAsset.value.id : null;
};

const loadAssets = async () => {
  try {
    const response = await assetService.getAssets();
    assets.value = response; // Adjust mapping if backend structure differs
  } catch (error) {
    console.error("Error fetching assets:", error);
  }
};
loadAssets();

const fetchMaintenance = async () => {
  loading.value = true;
  try {
    const response = await assetService.getMaintenance();
    maintenanceData.value = response;
    loading.value = false;
  } catch (error) {
    console.error("Error fetching maintenance data:", error);
    loading.value = false;
  }
};

const openMaintenanceModal = () => {
  isEditing.value = false;
  displayModal.value = true;
  form.value = {
    assetId: "",
    details: "",
    maintenanceAgent: "",
    cost: "",
    scheduledDate: "",
    maintenanceDate: "",
    status: null,
  };
};

const openEditModal = async (id) => {
  const record = await assetService.getMaintenanceById(id);
  // form.value = record;

  // currentEditId.value = id;
  // isEditing.value = true;
  // displayModal.value = true;

  isEditing.value = true;
  displayModal.value = true;
  currentEditId.value = id;

  form.value = {
    assetId: record.assetId,
    details: record.details,
    maintenanceAgent: record.maintenanceAgent,
    cost: record.cost,
    scheduledDate: record.scheduledDate,
    maintenanceDate: record.maintenanceDate,
    status: maintenanceStatus[record.status], // ✅ convert number to text
  };

  // Set selected dropdown for Asset Name
  selectedAssetId.value = record.assetId;
  selectedAsset.value = assets.value.find((a) => a.id === record.assetId);
};

const deleteMaintenance = async (id) => {
  try {
    await ElMessageBox.confirm(
      "Are you sure you want to delete this record?",
      "Confirm delete",
      {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      }
    );
    await assetService.deleteMaintenance(id);
    ElNotification({ type: "success", message: "Deleted successfully" });
    fetchMaintenance();
  } catch (error) {
    console.error("Delete error:", error);
  }
};

const handleSubmit = async () => {
  loading.value = true;

  // Convert string status to its index before submit
  if (typeof form.value.status === "string") {
    const statusIndex = maintenanceStatus.indexOf(form.value.status);
    if (statusIndex !== -1) {
      form.value.status = statusIndex;
    }
  }

  try {
    if (isEditing.value) {
      await assetService.updateMaintenance(currentEditId.value, form.value);
      ElNotification({ type: "success", message: "Updated successfully" });
    } else {
      await assetService.createMaintenance(form.value);
      ElNotification({ type: "success", message: "Added successfully" });
    }
    displayModal.value = false;
    fetchMaintenance();
  } catch (error) {
    console.error("Save error:", error);
  } finally {
    loading.value = false;
  }
};

// const handleSubmit = async () => {
//   loading.value = true;
//   try {
//     if (isEditing.value) {
//       await assetService.updateMaintenance(currentEditId.value, form.value);
//       ElNotification({ type: "success", message: "Updated successfully" });
//     } else {
//       await assetService.createMaintenance(form.value);
//       ElNotification({ type: "success", message: "Added successfully" });
//     }
//     displayModal.value = false;
//     loading.value = false;
//     fetchMaintenance();
//   } catch (error) {
//     console.error("Save error:", error);
//     loading.value = false;
//   }
// };

const handleSearchTextUpdate = (newValue) => {
  searchText.value = newValue;
};

const filteredData = computed(() => {
  if (!searchText.value.trim()) return maintenanceData.value;
  return maintenanceData.value.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchText.value.toLowerCase())
  );
});
const date = (offDate) => {
  return monthDayYear.monthDayYear(offDate);
};

onMounted(fetchMaintenance);
</script>
